import React from 'react';
import { Form } from 'react-bootstrap';

const locationSelect = (props) => {

  const options = props.locations.map(el => (
    <option key={el.id} value={el.id}>{el.name} - {el.address}</option>
  ));

  return (
    <Form.Group controlId="exampleForm.SelectCustomSizeLg">
      <Form.Label><i className="fa fa-map-marker"></i> Vali asukoht</Form.Label>
      <Form.Control as="select" size="lg" custom onChange={props.changed} value={props.selectedValue}>
        <option value="0">Vali</option>
        {options}
      </Form.Control>
    </Form.Group>
  );


};

export default locationSelect;